module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./WeekYear2View.js"));
	}, "WeekYear2View");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WeekYear2View!./src/pages/Shop/Home/Carnival/weekYear2/WeekYear2View.js
// module id = 1853
// module chunks = 367